var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"float-right mr-4 d-sm-none d-md-block",attrs:{"src":"images/avril_logo.jpg","width":"150","aspect-ratio":"1.7","contain":""}}),_vm._v(" "),_c('pre',{attrs:{"id":"contents"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }